import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DecisionUploadWarningContainer,
  DecisionUploadWarningTitle,
  DecisionUploadWarningIcon,
} from '../../components/DecisionUploadWarningComponents';
import styles from './decision_upload_error.module.scss';

type Props = {
  type: 'extension' | 'other';
};

export const DecisionUploadError: FC<Props> = ({ type }) => (
  <DecisionUploadWarningContainer>
    <DecisionUploadWarningIcon />
    <div>
      <DecisionUploadWarningTitle>
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadError.tsx/1" />
      </DecisionUploadWarningTitle>
      <div className={styles.message}>
        {type === 'other' && <DecisionUploadErrorOther />}
        {type === 'extension' && <DecisionUploadErrorExtension />}
      </div>
    </div>
  </DecisionUploadWarningContainer>
);

const DecisionUploadErrorOther: FC = () => (
  <>
    <FormattedMessage id="upload/decision-upload/components/DecisionUploadError.tsx/2" />{' '}
    <button
      type="button"
      className={styles.help}
      onClick={() => window.Intercom('show')}
    >
      <FormattedMessage id="upload/decision-upload/components/DecisionUploadError.tsx/3" />
    </button>{' '}
    <FormattedMessage id="upload/decision-upload/components/DecisionUploadError.tsx/4" />
  </>
);

const DecisionUploadErrorExtension: FC = () => (
  <FormattedMessage id="upload/decision-upload/components/DecisionUploadError.tsx/5" />
);
